import React, { useCallback } from "react";
import { useFormikContext } from "formik";
import { FORM_KEY } from "utils/constants/form";
import classnames from "classnames";
import { useDropzone } from "react-dropzone";
import { useViewport } from "utils/context";
import { encode } from "js-base64";
import { useCtxReferences, useIsAuthed } from "utils/selectors";
import InfoNotice from "components/InfoNotice";
import { interpolateRoute } from "utils/route";
import Link from "next/link";
import PATHS from "utils/paths";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";
import { SETTINGS_TABS } from "utils/constants/settings";
import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";

const FilePicker = () => {
  const { isSmall } = useViewport();
  const { setValues, values } = useFormikContext();
  const isAuthed = useIsAuthed();

  const { application } = useCtxReferences();

  const brandingRoute = isAuthed
    ? `${interpolateRoute(PATHS.HUB_APPLICATIONS_SHOW, {
        application
      })}/${HUB_APP_SUB_SECTION.SETTINGS}?tab=${SETTINGS_TABS.BRANDING}`
    : "";

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();

    reader.onabort = () => console.log("file reading was aborted");
    reader.onerror = () => console.log("file reading has failed");
    reader.onload = () => {
      const binaryStr = reader.result;

      const converted = encode(binaryStr);
      const fileType = file.type;
      const dataUri = `data:${fileType};base64,${converted}`;
      const type = fileType.split("/").pop();

      const updatedValues = cloneDeep(values);
      set(updatedValues, "image", dataUri);
      set(updatedValues, `${FORM_KEY}.extension`, type);
      setValues(updatedValues);
    };

    reader.readAsArrayBuffer(file);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/jpeg, image/png, image/svg+xml",
    maxFiles: 1
  });

  const message = isSmall
    ? "Tap to pick a brand icon"
    : isDragActive
    ? "Drop the file here ..."
    : "Drop a brand icon here, or click to pick a file";
  return (
    <div className="w-100">
      <div
        {...getRootProps()}
        className={classnames(
          "ba br2 pa3 flex flex-row items-center justify-center justify-between-ns bg-white--hover pointer",
          {
            "hairline-1": !isDragActive,
            "b--primary": isDragActive
          }
        )}
      >
        <img width={22} src={values.image}></img>
        <input {...getInputProps()} />
        <div className="f6 ph2">{message}</div>
      </div>
      {isAuthed && (
        <div className="pt3">
          <InfoNotice
            hideIcon
            copy="Saved icon inherited from brand settings."
            customClasses={{
              container:
                "w-100 flex flex-row ba br2 hairline-1 pa2 items-center bg-content--secondary justify-between"
            }}
          >
            <Link href={brandingRoute}>
              <span className="f7 f6-ns fw6 link color-primary link__decoration--hover pointer pl1">
                Edit
              </span>
            </Link>
          </InfoNotice>
        </div>
      )}
    </div>
  );
};

export default FilePicker;
